import React, { Component } from "react";
import { Fragment } from "react";
import SectionLayout from "../../../utility/ui-components/sectionLayout";

function ProductContentSections(props) {
  const data = props.content;
  return (
    <Fragment>
      {data &&
        data.map((item) => (
          <SectionLayout keys={item.id} content={item.content} />
        ))}
    </Fragment>
  );
}

export default ProductContentSections;
